export const zipCodeCzSkRegex = /^\d{3}\s*\d{2}$/;

// export const bankAccountCzechRegex = /^\d{2,6}?-?\d{2,10}\/\d{4}$/;
// export const bankAccountIBANRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/i;
export const bankAccountCombinedRegex =
  /^(?:\d{2,6}-?\d{2,10}\/\d{4}|[A-Z]{2}\d{2}[A-Z0-9]{11,30})$/i;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const birthNumberRegex = /^\d{6}\/?\d{3,4}$/;

export const twoFACodeRegex = /^\d{6}$/;
